import { SnackbarType } from '@/interface/snackbar.interface';
import { clearAllSnackbars, hideSnackbar, showSnackbar } from '@/store/feature/snackbarSlice';
import { AppDispatch } from '@/store/store';
import { useDispatch } from 'react-redux';

export const useSnackbar = () => {
  const dispatch = useDispatch<AppDispatch>();

  const show = (message: string, type: SnackbarType = 'info', duration: number = 4000) => {
    dispatch(showSnackbar({ message, type, duration }));
  };

  const hide = (id: string) => {
    dispatch(hideSnackbar(id));
  };

  const clearAll = () => {
    dispatch(clearAllSnackbars());
  };

  return {
    showSnackbar: show,
    hideSnackbar: hide,
    clearAllSnackbars: clearAll
  };
};